import * as eventService from 'utils/services/events';
import Event from 'models/Event';
import * as types from '../../types/matchScoresheet';

const getMatchEventDetailsBegin = () => {
  return {
    type: types.GET_MATCH_EVENT_DETAILS_BEGIN
  }
}

const getMatchEventDetailsError = () => {
  return {
    type: types.GET_MATCH_EVENT_DETAILS_ERROR
  }
}

const getMatchEventDetailsSuccess = (eventDetails) => {
  return {
    type: types.GET_MATCH_EVENT_DETAILS_SUCCESS,
    payload: {
      eventDetails
    }
  }
}

const getEventDetails = (eventId) => {
  return async dispatch => {
    dispatch(getMatchEventDetailsBegin())
    try {
      const {included, data} = await eventService.getEventById(eventId);
      const eventDetails = new Event(data, included);
      const formattedEvent = {
        eventLocation: eventDetails.getEventLocation(),
        eventId: eventDetails.eventId,
        eventDate: eventDetails.parseStartEndTimeShortenedString(),
        eventName: eventDetails.name,
        programId: eventDetails.programId,
        season: eventDetails.getSeason()
      }
  
      dispatch(getMatchEventDetailsSuccess(formattedEvent))

    } catch(err) {

      dispatch(getMatchEventDetailsError())
      throw err;
    }

  }
}

export default getEventDetails